
import { tryFind, toList as toList_1, add, ofArray, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ofNullable } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { toFloat64 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/BigInt.js";
import { fromDate, utcNow, toUnixTimeMilliseconds } from "../../fable_modules/fable-library-js.5.0.0-rc.2/DateOffset.js";
import { singleton, collect, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";

function storageKey(userId) {
    return `chat_last_read_${userId}`;
}

export function getLastReadTimestamps(userId) {
    try {
        const json = ofNullable(localStorage.getItem(storageKey(userId)));
        if (json == null) {
            return empty({
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            });
        }
        else {
            const j = json;
            const parsed = JSON.parse(j);
            return ofArray(map((tupledArg) => [tupledArg[0], tupledArg[1]], Object.entries(parsed)), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            });
        }
    }
    catch (matchValue) {
        return empty({
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        });
    }
}

export function markConversationRead(userId, conversationId) {
    const current = getLastReadTimestamps(userId);
    const updated = add(conversationId, toFloat64(toUnixTimeMilliseconds(utcNow())), current);
    const obj = createObj(toList(delay(() => collect((matchValue) => singleton([matchValue[0], matchValue[1]]), toList_1(updated)))));
    localStorage.setItem(storageKey(userId), JSON.stringify(obj));
}

export function isUnread(username, lastReadMap, conversation) {
    const matchValue = conversation.LastMessage;
    if (matchValue != null) {
        const lastMsg = matchValue;
        if (lastMsg.SenderUsername === username) {
            return false;
        }
        else {
            const msgTimestamp = toFloat64(toUnixTimeMilliseconds(fromDate(lastMsg.CreatedAt)));
            const matchValue_1 = tryFind(conversation.Id, lastReadMap);
            if (matchValue_1 != null) {
                return msgTimestamp > matchValue_1;
            }
            else {
                return true;
            }
        }
    }
    else {
        return false;
    }
}

